export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-900 pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20collage%20of%20vintage%20newspaper%20clippings%20polaroid%20photos%20and%20glowing%20phone%20screens%20scattered%20on%20warm%20dark%20amber%20backdrop%2C%20cinematic%20dramatic%20lighting%2C%20documentary%20newsroom%20mood%2C%20film%20grain%2C%20moody%20texture&width=1800&height=1000&seq=hero-chigua-01&orientation=landscape"
          alt="吃瓜合集娱乐热点追踪封面背景图"
          className="h-full w-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-background-950/40 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-white backdrop-blur-sm md:text-sm">
          <i className="ri-flashlight-fill text-primary-300" aria-hidden="true"></i>
          连续剧瓜 · 系列爆料 · 一次吃透
        </span>

        <h1 className="max-w-4xl font-heading text-3xl font-bold leading-tight text-white md:text-6xl">
          吃瓜合集 · 连载事件
          <span className="block text-primary-300 md:inline"> 全程追踪</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          把散落在各个平台的连续剧瓜、系列爆料按时间线整理成串。点开即可获取完整时间线与追踪报道，
          事件全记录持续更新，帮你顺着时间线看下去，不错过每次后续。
        </p>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#serial"
            className="w-full whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-400 sm:w-auto md:text-base"
          >
            开始追连载瓜
          </a>
          <a
            href="#hot"
            className="w-full whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto md:text-base"
          >
            查看今日热榜
          </a>
        </div>

        <div className="mt-12 flex w-full max-w-3xl flex-wrap items-center justify-center gap-x-8 gap-y-3 text-background-100 md:gap-x-12">
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-white md:text-3xl">1200+</p>
            <p className="mt-1 text-xs text-background-200 md:text-sm">事件全程整理</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-white md:text-3xl">860+</p>
            <p className="mt-1 text-xs text-background-200 md:text-sm">连载瓜持续追更</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-white md:text-3xl">24h</p>
            <p className="mt-1 text-xs text-background-200 md:text-sm">热点即时跟进</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-white md:text-3xl">96%</p>
            <p className="mt-1 text-xs text-background-200 md:text-sm">读者满意度</p>
          </div>
        </div>
      </div>
    </section>
  );
}